<template>
  <div class="privacy" v-if="policyDocument">
    <modal v-if="isModalOpen" @close="closeModal">
      <div slot="header" class="privacy__header">
        <h1>{{ $t('Web.Profile.Buttons.Privacy') }}</h1>
      </div>
      <div slot="body" class="privacy__body">
        <div v-if="policyDocument">
          <div v-html="$sanitize(decodeLegalDocs(policyDocument))"></div>
        </div>
      </div>
      <div slot="footer"></div>
    </modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import _has from 'lodash/has';
import Modal from '../_common/modal.vue';

export default {
  name: 'privacy',
  components: { Modal },
  data() {
    return {
      isModalOpen: true
    };
  },

  beforeCreate() {
    this.$showGlobalLoadingSpinner();
    this.$store
      .dispatch('getPrivacyPolicyKey')
      .then(() => {
        this.$store.dispatch('getAcceptedPolicy');
      })
      .finally(() => {
        this.$hideGlobalLoadingSpinner();
      });
  },

  methods: {
    decodeLegalDocs(response) {
      if (_has(response.data, 'html')) {
        try {
          const content = atob(response.data.html);
          return decodeURIComponent(escape(content));
        } catch (e) {
          return 'Fehler. Es wird kein valides Dokument ausgeliefert.';
        }
      }
    },
    closeModal() {
      // if there is a previous route, navigate to it. Otherwise go to home route.
      // We check for > 2 because an empty browser tab/page counts already as one
      // and we want to ensure that closing this modal will not lead to a blank tab/page.
      if (window.history && window.history.length > 2) {
        this.$router.go(-1);
      } else {
        this.$router.push('/home');
      }
    }
  },
  computed: {
    ...mapGetters(['policyDocument'])
  }
};
</script>

<style lang="scss">
.privacy {
  font-family: $font-siemens;

  h1 {
    margin: 0 auto;
    text-align: center;
    font-size: 24px;
  }

  h2,
  h3 {
    margin: 48px 0 20px;
    color: $charcoal-grey;
    font-size: 24px;
  }

  ul {
    margin-left: 15px;

    & > li {
      list-style: disc;
    }
  }

  p {
    margin: 15px 0;
  }

  li {
    margin: 0 0 0 15px;
  }

  &__body {
    padding: 0 10px 30px 10px;
    font-size: 16px;

    h1 {
      display: none;
    }
  }
}
</style>
